module.exports = __webpack_public_path__ + "static/media/f1.d057163d.png";